import React from 'react';

import { Wrap } from '@components';
import { Outlet } from 'react-router-dom';

const ChartPage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default ChartPage;
